import script from "./CollectivitesManagementInformations.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectivitesManagementInformations.vue?vue&type=script&setup=true&lang=ts"

import "./CollectivitesManagementInformations.vue?vue&type=style&index=0&id=4cbc3b9c&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cbc3b9c"]])

export default __exports__